var _path, _path2, _path3, _path4, _path5, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8267 2.66675H12.16C5.49333 2.66675 2.82666 5.33342 2.82666 12.0001V20.0001C2.82666 26.6667 5.49333 29.3334 12.16 29.3334H20.16C26.8267 29.3334 29.4933 26.6667 29.4933 20.0001V13.3334",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6659 2.91996L19.9641 8.62255C19.747 8.83965 19.5299 9.26663 19.4865 9.57781L19.1754 11.7561C19.0596 12.5449 19.6168 13.0949 20.4055 12.9863L22.5834 12.6752C22.8873 12.6317 23.3142 12.4146 23.5385 12.1975L29.2403 6.49494C30.2244 5.51073 30.6875 4.36732 29.2403 2.91996C27.7932 1.4726 26.6499 1.93576 25.6659 2.91996Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1602 4C25.567 5.45142 26.7027 6.58704 28.1602 7",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16016 24H18.1602",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16016 19H24.1602",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.16016,
    y: 8,
    width: 6,
    height: 6,
    rx: 1,
    stroke: "#292D32",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.2355dec5.svg";
export { ForwardRef as ReactComponent };